import { CategoryDownloadDto, ContentController, ControllerHelper } from 'collaboration-service';
import { ImgSelect } from 'imaginarity-react-ui';
import * as _ from "lodash";
import * as React from 'react';
import { getTranslated } from 'services/Helpers/TranslationHelpers';
import { useImgI18N } from 'services/ImgI18N';
import { BaseEditItem, useSelectorGPE } from '../GeneralPostEdit';
import { GeneralPostEditState } from '../GeneralPostEditStateHandling';
import { useGPEState } from '../Helpers/UseGPEState';
import { PostEditElementProps } from '../TypeImplementations/PostEdit';

interface EditCategoryLikeProps<T, S> extends PostEditElementProps<T, S> {
    toSelect: keyof GeneralPostEditState;
}

const EditCategoryLike = <T extends BaseEditItem = BaseEditItem, S extends CategoryDownloadDto = CategoryDownloadDto>(p: EditCategoryLikeProps<T, S>) => {
    const { value: val, setValue: setVal } = useGPEState(p.getter);
    const { currentLanguage } = useImgI18N();
    const [opt, setOpt] = React.useState<Array<{ label: string, value: string }>>();
    const categories = useSelectorGPE(s => (s as any)[p.toSelect] as CategoryDownloadDto[]);
    const [loadedCategory, setLoadedCategory] = React.useState<S>();
    const chg = React.useMemo(() => (val: { label: string, value: string }) => {
        const toSel = _.find(categories, c => c.id === val.value)! as S;
        setVal(toSel);
    }, [categories, setVal]);

    React.useEffect(() => {
        const load = async (id: string) => {
            var cat = await ControllerHelper.singleCall({ id }, ContentController.GetCategoryById, true) as S;
            if (cat) {
                setLoadedCategory(cat);
            }
        };
        if (val && _.find(categories, c => c.id === val?.id) === undefined)
            load(val.id);
    }, [val, categories]);

    React.useEffect(() => {
        setOpt(_.map(loadedCategory ? _.union([loadedCategory], categories) : categories, c => ({ value: c.id, label: getTranslated(c.names, currentLanguage).text })))
    }, [categories, currentLanguage, loadedCategory])


    if (!opt)
        return <div />;

    const selVal = _.find(opt, o => o.value === val?.id);
    return (
        <ImgSelect
            options={opt}
            value={selVal}
            onChange={chg}
        />
    );
}
export default EditCategoryLike;